import { PurchasePointsErrorState } from "@/features/purchasePoints/components/PurchasePointsErrorState";
import { RewardHistoryRow } from "@/features/purchasePoints/components/RewardHistory/RewardHistoryRow";
import {
  LATEST_REWARDS_TITLE,
  REWARD_HISTORY_EMPTY_MESSAGE,
  REWARD_HISTORY_ERROR_MESSAGE,
} from "@/features/purchasePoints/config/purchasePoints.config";
import type { PurchasePointsError } from "@/features/purchasePoints/errors/purchasePointsError";
import type { PurchasePointsReward } from "@/features/purchasePoints/types/purchasePointsReward.type";
import { P } from "@/shared/ui/typographies/paragraph";

type LatestRewardsProps = {
  rewards: PurchasePointsReward[]
  error: PurchasePointsError | null
  retry: () => void
};

const TITLE_ID = "purchase-points-summary-rewards-title";

export const LatestRewards = ({ rewards, error, retry }: LatestRewardsProps) => (
  <section aria-labelledby={TITLE_ID} data-testid="purchase-points-summary-rewards">
    <h3 id={TITLE_ID} className="mb-3 text-sm font-semibold text-gray-900 dark:text-white">
      {LATEST_REWARDS_TITLE}
    </h3>

    {error && (
      <div role="alert" data-testid="purchase-points-summary-rewards-error">
        <PurchasePointsErrorState error={error} onRetry={retry} fallbackMessage={REWARD_HISTORY_ERROR_MESSAGE} />
      </div>
    )}

    {!error && rewards.length === 0 && (
      <div role="status" data-testid="purchase-points-summary-rewards-empty">
        <P>{REWARD_HISTORY_EMPTY_MESSAGE}</P>
      </div>
    )}

    {!error && rewards.length > 0 && (
      // Tailwind's preflight strips the bullets, and with them the list role
      // Safari exposes to VoiceOver.
      <ul role="list" className="flex flex-col">
        {rewards.map((reward) => <RewardHistoryRow key={reward.id} reward={reward} />)}
      </ul>
    )}
  </section>
);

LatestRewards.displayName = "LatestRewards";
